<template>
  <div class="map-item-filter">
    <div
      class="col-sm-12 nopads vehicle-list"
    >
      <span
        class="vehicle-list-title"
        @click.stop="toggleList"
      >
        {{ $t('menu.traffic_signs') }}
      </span>
      <div
        class="vehicle-list-caret"
        :class="{ caret_open: listOpen }"
        @click.stop="toggleList"
      >
        <font-awesome-icon icon="caret-down" />
      </div>
      <div
        class="col-sm-12 nopads map-accordion-content"
        :class="{ 'map-accordion-open': listOpen }"
      >
        <div :class="{ 'm-2': listOpen }">
            <div class="d-flex flex-wrap gap-2 mb-3">
                  <span
                      v-for="item in timeFilters"
                      :key="item.value"
                      class="badge"
                      :class="isActiveTimeFilter(item.value) ? 'bg-primary text-white' : 'bg-light text-dark'"
                      style="padding: .5em 1em; cursor: pointer"
                      @click="toggleTimeFilter(item.value)"
                  >
                    {{ item.text }}
                  </span>
            </div>
            <span class="span-title text-white">{{ $t('road_sign.condition') }}</span>

            <div class="col-12" :class="{ 'multiselect-expand': multiselectOpen }">
                <multiselect
                    v-model="condition"
                    class="condition-multiselect"
                    :placeholder="$t('road_sign.condition')"
                    :deselect-label="$t('common.remove_selection')"
                    :select-label="$t('common.select')"
                    :close-on-select="false"
                    :multiple="true"
                    label="name"
                    track-by="value"
                    :searchable="true"
                    :internal-search="true"
                    :selected-label="$t('common.selected')"
                    :options="getConditions()"
                    :open-direction="'below'"
                    :max-height="300"
                    @open="multiselectOpen = true"
                    @close="multiselectOpen = false"
                >
                    <template #singleLabel="props">
                        <div class="row gx-0">
                            <div class="col pt-1">
                              <span class="option__title fw-normal">
                                {{ props.option.name }}
                              </span>
                            </div>
                        </div>
                    </template>

                    <template #option="props">
                        <div class="row gx-0">
                            <div class="col pt-2">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                        </div>
                    </template>

                    <template #noResult>
                        <span>{{ $t('common.not_found') }}</span>
                    </template>

                    <template #noOptions>
                        <span>{{ $t('common.no_results') }}</span>
                    </template>
                </multiselect>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {restApi} from '../mixins/RestApiMixin'
import {roadSignHelper, roadSignTypes} from "@/components/mixins/RoadSignMixin";
const STATUS = {
    ALL: 0,
    ACTIVE: 1,
    DELETED: 2,
}
// Allow selection of multiple time filters
// const INIT_STATUS = [STATUS.ALL]
const INIT_STATUS = STATUS.ACTIVE
export default {
    name: "RoadSignFilter",
    mixins: [restApi, roadSignHelper, roadSignTypes],
    data() {
        return {
            isOpen: true,
            loading: false,
            listOpen: false,
            multiselectOpen: false,
            condition: [],
            selectedTimeFilters: INIT_STATUS,
            timeFilters: [
                {
                    text: this.$t("common.all"),
                    value: STATUS.ALL,
                },
                {
                    text: this.$t("common.active"),
                    value: STATUS.ACTIVE,
                },
                {
                    text: this.$t("common.closed"),
                    value: STATUS.DELETED,
                },
            ],
        };
    },
    computed: {
        amountOfFiltersSelected() {
            return (this.selectedTimeFilters ? 1 : 0) + (this.selectedContractId ? 1 : 0)
        }
    },
    watch: {
        selectedTimeFilters(val) {
            this.$emit('filtersUpdated', val)
        },
        condition(val) {
            this.$emit('filtersUpdated', this.selectedTimeFilters, val)
        }
    },
    methods: {
        toggleTimeFilter(val) {
            this.selectedTimeFilters = val
        },
        isActiveTimeFilter(val) {
            return val === this.selectedTimeFilters
        },
        toggleList: function () {
            this.listOpen = !this.listOpen
        },
    },
}
</script>
<style lang="scss" scoped>
.badge-filters {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    flex: 5;
    flex-wrap: wrap;
    & > * {
        cursor: pointer;
    }
    &__wrapper {
        display: flex;
        align-items: flex-start;
    }
}

.multiselect-expand {
    height: 300px;
    vertical-align: top;
}

.condition-multiselect :deep(.multiselect__content-wrapper) {
    max-height: unset !important;
    height: 260px !important;
}
</style>
